import { formatUnit } from '@syncfusion/ej2-base';
import { contentReady, uiUpdate, scrollUiUpdate } from '../base/constant';
/**
 * `Scroll` module
 */
export class Scroll {
    /**
     * Constructor for the scrolling.
     *
     * @param {Schedule} parent Accepts the Schedule instance
     */
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} Returns the module name.
     * @private
     */
    getModuleName() {
        return 'scroll';
    }
    /**
     * Internal method to set the element width
     *
     * @returns {void}
     * @private
     */
    setWidth() {
        this.parent.element.style.width = formatUnit(this.parent.width);
    }
    /**
     * Internal method to set the element height
     *
     * @returns {void}
     * @private
     */
    setHeight() {
        this.parent.element.style.height = formatUnit(this.parent.height);
    }
    /**
     * Internal method to bind events
     *
     * @returns {void}
     * @private
     */
    addEventListener() {
        this.parent.on(contentReady, this.setDimensions, this);
        this.parent.on(uiUpdate, this.onPropertyChanged, this);
    }
    /**
     * Internal method to unbind events
     *
     * @returns {void}
     * @private
     */
    removeEventListener() {
        this.parent.off(contentReady, this.setDimensions);
        this.parent.off(uiUpdate, this.onPropertyChanged);
    }
    /**
     * Internal method to set the dimensions
     *
     * @returns {void}
     * @private
     */
    setDimensions() {
        this.setWidth();
        this.setHeight();
        const data = { cssProperties: this.parent.getCssProperties(), module: this.getModuleName() };
        this.parent.notify(scrollUiUpdate, data);
    }
    /**
     * Internal method to set the dimensions dynamically
     *
     * @returns {void}
     * @private
     */
    onPropertyChanged() {
        this.setDimensions();
    }
    /**
     * Destroy the scroll module
     *
     * @returns {void}
     * @private
     */
    destroy() {
        this.removeEventListener();
    }
}
